import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const WrapperButtonGeneralSumary = styled.div`
  cursor: pointer;
  width: 100%;
  border-radius: ${tokens.radius.large};
  padding: ${tokens.spacing.insetXsmall};
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${tokens.colors.dark5};
  }
`

export const WrapperGeneralSumary = styled.div`
  padding: ${tokens.spacing.horizontalXsmall};
  padding-left: ${tokens.spacing.horizontalSmall};
  display: flex;
  align-items: center;
`

export const TextGeneralSumary = styled.p`
  margin: 0 0 0 ${tokens.spacing.horizontalSmall};
  color: ${tokens.colors.dark0};
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.large}%;
`
